module.exports = __webpack_public_path__ + "static/media/Mobility_modern.89a53541.png";